import { FacilityEntrySchema } from '#app/routes/mocra+/_form+/components/facilities/schema.ts'
import {
	collectFacilityErrors,
	createFacilityDraft,
	facilityDraftToEntry,
	facilityEntryToDraft,
	sanitizeFacilityDraft,
	type FacilityDraft,
} from '#app/routes/mocra+/_form+/components/facilities/types.ts'
import { assertEntityDefinition } from '#app/routes/mocra+/_form+/entity-definition.ts'

export const facilityDefinition = assertEntityDefinition({
	schema: FacilityEntrySchema,
	createDraft: () => createFacilityDraft(),
	sanitizeDraft: sanitizeFacilityDraft,
	serialize: facilityDraftToEntry,
	deserialize: facilityEntryToDraft,
	collectErrors: collectFacilityErrors,
})

export type FacilityEntityDraft = FacilityDraft
